import API from '@aws-amplify/api'
import { API_NAME } from '../const';
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

export async function getImageDownloadUrlForAdmin(
  s3_file_path: string,
): Promise<string> {
  await checkCurrentAuthenticatedUser()
  const res = await API.get(API_NAME, '/v2/download/' + s3_file_path, {}).catch(err => {
    return err.response;
  });
  return res ? res?.url : '';
}
